import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import style from "./product-description-header.css";

function ProductDescriptionHeader({
    className,
    designerName,
    designerUrl,
    isDesignerActive,
    shortDescription,
}) {
    return (
        <div className={classnames(className, style.wrapper)}>
            <div className={style.titleWrapper}>
                <h1 className={style.title}>
                    <div className={style.designerName}>
                        {isDesignerActive && designerUrl ? (
                            <a href={designerUrl} className={style.designerLink}>
                                {designerName}
                            </a>
                        ) : (
                            <span>{designerName}</span>
                        )}
                    </div>
                    <span className={style.shortDescription}>{" " + shortDescription}</span>
                </h1>
            </div>
        </div>
    );
}

ProductDescriptionHeader.defaultProps = {
    isDesignerActive: false,
};

ProductDescriptionHeader.propTypes = {
    absoluteUrl: PropTypes.string,
    className: PropTypes.string,
    designerName: PropTypes.string.isRequired,
    designerUrl: PropTypes.string,
    isDesignerActive: PropTypes.bool,
    productId: PropTypes.string,
    shortDescription: PropTypes.string.isRequired,
};

export default ProductDescriptionHeader;
